import { FormattedMessage } from 'react-intl'
import { useDispatch, useSelector } from 'react-redux'

// Redux
import {
  setContactHomebotStepAdvanceOneStep,
  setContactHomebotShowModal,
  setContactHomebotAcceptedDisclaimer,
  selectContactHomebotStep,
  setContactHomebotStep,
  STEPS_CONST,
  STEPS,
} from 'src/store/slices/contactHomebot'

// Components
import Step from '../../../../../ModalStepsOutline'
import { Text } from 'src/Components'

// Styles
import styles from './Disclaimer.module.scss'

export const Disclaimer = () => {
  const dispatch = useDispatch()
  const currentStep = useSelector(selectContactHomebotStep)
  const stepIndex = STEPS_CONST.indexOf(currentStep)

  const handleNextStepButtonClick = () => {
    dispatch(setContactHomebotAcceptedDisclaimer(true))
    dispatch(setContactHomebotStepAdvanceOneStep())
  }

  const handleNevermindButtonClick = () => {
    dispatch(setContactHomebotShowModal(false))
  }

  return (
    <Step stepLabel='contact-homebot-location'>
      <Step.HeaderNavSection
        currentStep={currentStep}
        steps={STEPS}
        onCancel={() => dispatch(setContactHomebotShowModal(false))}
        onBack={() =>
          dispatch(setContactHomebotStep(STEPS_CONST[stepIndex - 1]))
        }
      />
      <Step.Title className={styles.title}>
        <FormattedMessage
          id='ContactHomebot.disclaimer.step.title'
          defaultMessage="You're about to contact Homebot for this listing, and not your loan officer."
        />
      </Step.Title>
      <Step.Body className={styles.bodySection}>
        <Text variant='neutralCool' variantCount='700'>
          <FormattedMessage
            id='ContactHomebot.disclaimer.step.subtitle'
            defaultMessage='As part of this, your email address, this listing, and any comments you provide will be sent directly to Homebot.'
          />
        </Text>
      </Step.Body>
      <Step.FooterButton onClick={handleNextStepButtonClick}>
        <FormattedMessage
          id='ContactHomebot.continue.button'
          defaultMessage='Continue'
        />
      </Step.FooterButton>
      <Step.FooterButton optIn onClick={handleNevermindButtonClick}>
        <FormattedMessage
          id='ContactHomebot.nevermind.button'
          defaultMessage='Nevermind'
        />
      </Step.FooterButton>
    </Step>
  )
}
